import './Layout.css';

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopNavigationBar from './top_navigation_bar/TopNavigationBar';
import { Box } from '@mui/material';
import MarIaSideBar from '../b2b-mar-ia/MarIaSideBar';
import Notification from '../b2b-common/Notification';
import { useLoginContext } from '../../App';

const B2BContentContext = React.createContext();

const Layout = ({ sidebarOpen, selectedItem, children }) => {
    const [notification, setNotification] = useState(null);
    const { marIaSideBarOpen } = useLoginContext();

    return (
        <Box className="b2b-layout">
            <B2BContentContext.Provider value={{ setNotification }}>
                <Box className="b2b-top-bar">
                    <TopNavigationBar />
                </Box>
                <Box className={`b2b-main-container ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${marIaSideBarOpen ? 'mar-ia-sidebar-open' : 'mar-ia-sidebar-closed'}`}>
                    <Sidebar />
                    <Box className="b2b-content">
                        {children}
                    </Box>
                    <MarIaSideBar />
                    <Notification notification={notification} />
                </Box>
            </B2BContentContext.Provider>
        </Box>
    );
};

export { B2BContentContext };
export const useContentContext = () => React.useContext(B2BContentContext);
export default Layout;

